import React from 'react';
import propTypes from 'prop-types';
import { getCompany } from 'helpers/getCompanyVariables';
import { cn } from 'lib/utils';

const company = getCompany();

const PENDING_AGENT_ACTION_DOT = 'bg-semantic-danger';

export default function Statuses({
  actionableOnly = false,
  containerClassName = '',
  reverse = false
}) {
  return (
    <div className={cn('flex flex-col gap-1', containerClassName)}>
      <div
        className={cn(
          'flex items-center gap-1',
          reverse && 'flex-row-reverse'
        )}
      >
        <div
          className={cn(
            'h-[11px] w-[11px] rounded-full',
            PENDING_AGENT_ACTION_DOT
          )}
        />
        <span className='pt-0.5 text-sm font-medium'>
          Pending Agent Action
        </span>
      </div>
      {!actionableOnly && (
        <>
          <div
            className={cn(
              'flex items-center gap-1',
              reverse && 'flex-row-reverse'
            )}
          >
            <div className='h-[11px] w-[11px] rounded-full bg-pending' />
            <span className='pt-0.5 text-sm font-medium'>Pending</span>
          </div>
          <div
            className={cn(
              'flex items-center gap-1',
              reverse && 'flex-row-reverse'
            )}
          >
            <div className='h-[11px] w-[11px] rounded-full bg-secondary' />
            <span className='pt-0.5 text-sm font-medium'>
              {company === 'oneill' ? 'Confirmed' : 'Active'}
            </span>
          </div>
        </>
      )}
    </div>
  );
}

Statuses.propTypes = {
  actionableOnly: propTypes.bool,
  containerClassName: propTypes.string,
  reverse: propTypes.bool
};
